import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "dropdown-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 2.25C3.48122 2.25 2.25 3.48122 2.25 5V11C2.25 12.5188 3.48122 13.75 5 13.75H19C20.5188 13.75 21.75 12.5188 21.75 11V5C21.75 3.48122 20.5188 2.25 19 2.25H5ZM3.75 5C3.75 4.30964 4.30964 3.75 5 3.75H19C19.6904 3.75 20.25 4.30964 20.25 5V11C20.25 11.6904 19.6904 12.25 19 12.25H5C4.30964 12.25 3.75 11.6904 3.75 11V5ZM3.5 16.25C3.08579 16.25 2.75 16.5858 2.75 17C2.75 17.4142 3.08579 17.75 3.5 17.75H20.5C20.9142 17.75 21.25 17.4142 21.25 17C21.25 16.5858 20.9142 16.25 20.5 16.25H3.5ZM2.75 21C2.75 20.5858 3.08579 20.25 3.5 20.25H20.5C20.9142 20.25 21.25 20.5858 21.25 21C21.25 21.4142 20.9142 21.75 20.5 21.75H3.5C3.08579 21.75 2.75 21.4142 2.75 21ZM14.0303 6.71967C13.7374 6.42678 13.2626 6.42678 12.9697 6.71967C12.6768 7.01256 12.6768 7.48744 12.9697 7.78033L14.4697 9.28033C14.7626 9.57322 15.2374 9.57322 15.5303 9.28033L17.0303 7.78033C17.3232 7.48744 17.3232 7.01256 17.0303 6.71967C16.7374 6.42678 16.2626 6.42678 15.9697 6.71967L15 7.68934L14.0303 6.71967Z"
    }, null, -1)
  ])))
}
export default { render: render }